import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

const FileReviewSection = ({ title, files, role }) => {
  const cardClassName = role === "district_admin" || "admin"
    ? "mb-4 bg-white shadow-lg p-3"
    : "mb-4";
  const cardHeaderClassName = role === "district_admin" || "admin" ? "p-4 padding-bottom-3 rounded-lg opacity-80 bg-teal-700 flex flex-row items-center justify-between" : "mb-4";
  return (
    <Card className={cardClassName}>
      <CardHeader className={cardHeaderClassName}>
        <CardTitle className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {files.map((file, idx) => (
            <div key={idx} className="space-y-1">
              <span className="text-muted-foreground text-sm">
                {file.label}
              </span>
              <div className="font-medium">
                {file.value || (
                  <span className="text-muted-foreground">Not provided</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default FileReviewSection;
